import { Button, Tabs } from "antd";
import CompanyItemMain from "./company-item-main";
import CompanyItemUsers from "./company-item-users";

const CompanyItem = ({ companyId, onClose }) => {

  return (
    <>
      {/* Overlay */}
      <div 
        className="cloud-modal-overlay" 
        onClick={() => onClose(false)}
      />
      
      {/* Modal Panel */}
      <div className="cloud-modal-license-order-keys">
        {/* Header */}
        <div className="cloud-modal-header">
          <h3>Редактирование компании</h3>
          <Button onClick={() => onClose(false)} type="text">×</Button>
        </div>

        {/* Content */}
        <div className="cloud-modal-content">
          <Tabs
            items={[
              {
                key: 'main',
                label: 'Основные',
                children: <CompanyItemMain companyId={companyId} onClose={onClose} />,
              },
              {
                key: 'users',
                label: 'Пользователи',
                children: <CompanyItemUsers companyId={companyId} />,
              },
            ]}
            type="card"
          />
        </div>
      </div>
    </>
  );
};

export default CompanyItem;
